import React, { useState, useEffect } from 'react';
import {object, func, bool} from 'prop-types';
import {CloneObject} from '../../../utils/helpers';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useForm } from '@laramie/ui';
import { InputEntidad, InputFormula, InputLista, InputSubTasa, InputTasa, ToolbarFormula, Accordion, FormLabel, Select, CheckboxButton, CheckboxButtonGroup, FormError } from '../../common';
import {validateFormula} from '../../../utils/validator';
import Modal from '../../common/Modal';
import {TIPS} from "../../../consts/tips";

const EmisionCuentaCorrienteModal = (props) => {

    const entityInit = {
        id: 0,
        idEmisionDefinicion: 0,
        idTasa: 0,
        idSubTasa: 0,
        idTipoMovimiento: 0,
        tasaCabecera: false,
        descripcion: "",
        formulaCondicion: "",
        formulaDebe: "",
        formulaHaber: "",
        vencimiento: 0,
        soloLectura: false,
        orden: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        listCalculos: [],
        listFunciones: []
    });

    const [toolbar, setToolbar] = useState({
        show: false,
        horizontal: false
    });

    const [editor, setEditor] = useState({
        fontSize: "md"
    });

    const [cabeceraOpen, setCabeceraOpen] = useState(true);

    const [formulasOpen, setFormulasOpen] = useState(true);

    const [queueEvents, setQueueEvents] = useState({
        timestamps: null,
        queue: []
    });

    const mount = () => {
        setState(prevState => {
            return {
                ...prevState,
                entity: props.data.entity,
                listCalculos: props.data.listCalculos,
                listFunciones: props.data.listFunciones
            };
        });
        formSet({
            idTasa: props.data.entity.idTasa,
            idSubTasa: props.data.entity.idSubTasa,
            idTipoMovimiento: props.data.entity.idTipoMovimiento,
            tasaCabecera: props.data.entity.tasaCabecera,
            descripcion: props.data.entity.descripcion,
            formulaCondicion: props.data.entity.formulaCondicion,
            formulaDebe: props.data.entity.formulaDebe,
            formulaHaber: props.data.entity.formulaHaber,
            vencimiento: props.data.entity.vencimiento,
            orden: props.data.entity.orden
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTasa: 0,
        idSubTasa: 0,
        idTipoMovimiento: 0,
        tasaCabecera: false,
        descripcion: "",
        formulaCondicion: "",
        formulaDebe: "",
        formulaHaber: "",
        vencimiento: 0,
        orden: 0
    });

    //handles
    const handleToolbarFormulaToogleHorizontal = (horizontal) => {
        setToolbar(prevState => {
            return {...prevState, horizontal: horizontal};
        });
    }
    const handleToolbarFormulaSelect = (event) => {
        const timestamps = new Date();
        let newQueue = queueEvents.queue.slice();
        newQueue.push({queueName: queueEvents.queueNameCurrent, timestamps: timestamps, ...event});

        setQueueEvents({
            queue: newQueue,
            timestamps: timestamps
        });
    }

    const { errorOf, validate } = useFormErrors(getErrors);

    const handleClickConfirm = () => {
        const errors = getErrors();
        if (errors.idTasa || errors.idSubTasa || errors.descripcion || errors.idTipoMovimiento || errors.orden) setCabeceraOpen(true);
        if (errors.formulaDebe || errors.formulaHaber || errors.formulaCondicion) setFormulasOpen(true);

        if (validate()) {

            let row = CloneObject(state.entity);
            row.idTasa = parseInt(formValues.idTasa);
            row.idSubTasa = parseInt(formValues.idSubTasa);
            row.idTipoMovimiento = parseInt(formValues.idTipoMovimiento);
            row.tasaCabecera = formValues.tasaCabecera;
            row.descripcion = formValues.descripcion;
            row.formulaCondicion = formValues.formulaCondicion;
            row.formulaDebe = formValues.formulaDebe;
            row.formulaHaber = formValues.formulaHaber;
            row.vencimiento = parseInt(formValues.vencimiento);
            row.orden = parseInt(formValues.orden);

            props.onConfirm(row);
        }
        ;
    }

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.orden.toString().length <= 0) errors.orden = VALIDATION_MESSAGE.REQUIRED;
        else if (formValues.orden <= 0) errors.orden = 'Ingresá un número mayor a cero';
        if (formValues.idTasa <= 0) errors.idTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idSubTasa <= 0) errors.idSubTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idTipoMovimiento <= 0) errors.idTipoMovimiento = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.descripcion.length <= 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED;

        const errorDebe = getFormulaError(formValues.formulaDebe, true);
        if (errorDebe) errors.formulaDebe = errorDebe;

        const errorHaber = getFormulaError(formValues.formulaHaber, true);
        if (errorHaber) errors.formulaHaber = errorHaber;

        const errorCondicion = getFormulaError(formValues.formulaCondicion, false);
        if (errorCondicion) errors.formulaCondicion = errorCondicion;

        return errors;
    }

    function getFormulaError(formula, obligatoria) {
        if (formula.length <= 0) return obligatoria ? VALIDATION_MESSAGE.REQUIRED : null;
        const error = validateFormula(formula);
        return error ? `Fórmula incorrecta: ${error}` : null;
    }

    function SetFormulaFontSizeUp() {
        let fontSize = editor.fontSize;
        if (fontSize === "xm") fontSize = "sm";
        else if (fontSize === "sm") fontSize = "md";
        else if (fontSize === "md") fontSize = "lg";

        if (fontSize !== editor.fontSize) {
            setEditor(prevState => {
                return {...prevState, fontSize: fontSize};
            });
        }
    }

    function SetFormulaFontSizeDown() {
        let fontSize = editor.fontSize;
        if (fontSize === "lg") fontSize = "md";
        else if (fontSize === "md") fontSize = "sm";
        else if (fontSize === "sm") fontSize = "xm";

        if (fontSize !== editor.fontSize) {
            setEditor(prevState => {
                return {...prevState, fontSize: fontSize};
            });
        }
    }

    function ToogleToolbarShow() {
        setToolbar(prevState => {
            return {
                show: !prevState.show,
                horizontal: false
            };
        });
    }

    return (
        <>

            <Modal
                size={(toolbar.show && !toolbar.horizontal) ? "xl" : "lg"}
                title={`Cuenta corriente: ${(state.entity.id > 0) ? state.entity.descripcion : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.EMISION_CUENTA_CORRIENTE_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div id="panel-main"
                                     className={(toolbar.show && !toolbar.horizontal) ? "col-12 col-lg-8" : "col-12"}>

                                    <Accordion title="Datos" open={cabeceraOpen} onToggle={setCabeceraOpen}>
                                        <div className="row form-basic">
                                            <div className="col-12 col-lg-6">
                                                <FormLabel htmlFor="idTasa" required>Tasa</FormLabel>
                                                <InputTasa
                                                    name="idTasa"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTasa') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTasa}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('idTasa')} />
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                <FormLabel htmlFor="idSubTasa" required>Sub tasa</FormLabel>
                                                <InputSubTasa
                                                    name="idSubTasa"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idSubTasa') ? 'is-invalid' : ''}`}
                                                    value={formValues.idSubTasa}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    idTasa={formValues.idTasa}
                                                />
                                                <FormError message={errorOf('idSubTasa')} />
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                                                <input
                                                    name="descripcion"
                                                    type="text"
                                                    placeholder=""
                                                    maxLength={1000}
                                                    className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                                    value={formValues.descripcion}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('descripcion')} />
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                <CheckboxButtonGroup label="Opciones">
                                                    <CheckboxButton
                                                        name="tasaCabecera"
                                                        label="Es la tasa cabecera"
                                                        checked={formValues.tasaCabecera}
                                                        onChange={formHandle}
                                                        disabled={!props.partidaUnificada || props.disabled}
                                                    />
                                                </CheckboxButtonGroup>
                                            </div>
                                            <div className="col-12 col-lg-6">
                                                <FormLabel htmlFor="idTipoMovimiento" required>Movimiento</FormLabel>
                                                <InputEntidad
                                                    name="idTipoMovimiento"
                                                    placeholder=""
                                                    tipName={TIPS.NAME.MODALS.TIPO_MOVIMIENTO_MODAL}
                                                    className={`form-control ${errorOf('idTipoMovimiento') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoMovimiento}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    entidad="TipoMovimiento"
                                                />
                                                <FormError message={errorOf('idTipoMovimiento')} />
                                            </div>
                                            <div className="col-6 col-lg-2">
                                                <FormLabel htmlFor="orden" required>Orden</FormLabel>
                                                <input
                                                    name="orden"
                                                    type="number"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('orden') ? 'is-invalid' : ''}`}
                                                    value={formValues.orden}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('orden')} />
                                            </div>
                                            <div className="col-6 col-lg-4">
                                                <label htmlFor="vencimiento"
                                                       className="form-label">Vencimiento</label>
                                                <Select
                                                    name="vencimiento"
                                                    className="form-control"
                                                    value={formValues.vencimiento}
                                                    options={[
                                                        {value: 0, label: '1er y 2do Vencimiento'},
                                                        {value: 1, label: '1er Vencimiento'},
                                                        {value: 2, label: '2do Vencimiento'}
                                                    ]}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                        </div>
                                    </Accordion>

                                    <Accordion
                                        title="Fórmulas"
                                        className="m-top-15"
                                        open={formulasOpen}
                                        onToggle={setFormulasOpen}
                                        actions={
                                            <div className="action m-right-20 m-top-10">
                                                {!props.disabled && !toolbar.show &&
                                                    <div onClick={() => ToogleToolbarShow()}
                                                         className="link float-end m-left-15">
                                                        <span className="material-symbols-outlined"
                                                              title="Mostrar asistente de fórmulas">
                                                            function
                                                        </span>
                                                    </div>
                                                }
                                                <div onClick={() => SetFormulaFontSizeDown()}
                                                     className="link float-end m-left-5">
                                                    <span className="material-symbols-outlined"
                                                          title="Disminuir tamaño de fuente">text_decrease</span>
                                                </div>
                                                <div onClick={() => SetFormulaFontSizeUp()}
                                                     className="link float-end m-left-5">
                                                    <span className="material-symbols-outlined"
                                                          title="Aumentar tamaño de fuente">text_increase</span>
                                                </div>
                                            </div>
                                        }
                                    >
                                        <div className="row ba">
                                            <div className="mb-3 col-12">
                                                <label htmlFor="formulaCondicion"
                                                       className="form-label">Condición</label>
                                                <InputFormula
                                                    name="formulaCondicion"
                                                    className={`form-control ${errorOf('formulaCondicion') ? 'is-invalid' : ''}`}
                                                    fontSize={editor.fontSize}
                                                    heightNormal={50}
                                                    value={formValues.formulaCondicion}
                                                    onChange={formHandle}
                                                    onFocus={() => setQueueEvents(prevState => ({
                                                        ...prevState,
                                                        queueNameCurrent: "Condicion"
                                                    }))}
                                                    disabled={props.disabled}
                                                    data={{
                                                        listVariables: [],
                                                        listCalculos: state.listCalculos,
                                                        listFunciones: state.listFunciones,
                                                        listParametros: [],
                                                        listElementos: [],
                                                        listTiposDeclaracionJurada: []
                                                    }}
                                                    queueEvents={queueEvents}
                                                    queueName="Condicion"
                                                />
                                                <FormError message={errorOf('formulaCondicion')} />
                                            </div>
                                            <div className="mb-3 col-12">
                                                <FormLabel htmlFor="formulaDebe" required>Debe</FormLabel>
                                                <InputFormula
                                                    name="formulaDebe"
                                                    className={`form-control ${errorOf('formulaDebe') ? 'is-invalid' : ''}`}
                                                    fontSize={editor.fontSize}
                                                    heightNormal={80}
                                                    value={formValues.formulaDebe}
                                                    onChange={formHandle}
                                                    onFocus={() => setQueueEvents(prevState => ({
                                                        ...prevState,
                                                        queueNameCurrent: "Debe"
                                                    }))}
                                                    disabled={props.disabled}
                                                    data={{
                                                        listVariables: [],
                                                        listCalculos: state.listCalculos,
                                                        listFunciones: state.listFunciones,
                                                        listParametros: [],
                                                        listElementos: [],
                                                        listTiposDeclaracionJurada: []
                                                    }}
                                                    queueEvents={queueEvents}
                                                    queueName="Debe"
                                                />
                                                <FormError message={errorOf('formulaDebe')} />
                                            </div>
                                            <div className="mb-3 col-12">
                                                <FormLabel htmlFor="formulaHaber" required>Haber</FormLabel>
                                                <InputFormula
                                                    name="formulaHaber"
                                                    className={`form-control ${errorOf('formulaHaber') ? 'is-invalid' : ''}`}
                                                    fontSize={editor.fontSize}
                                                    heightNormal={80}
                                                    value={formValues.formulaHaber}
                                                    onChange={formHandle}
                                                    onFocus={() => setQueueEvents(prevState => ({
                                                        ...prevState,
                                                        queueNameCurrent: "Haber"
                                                    }))}
                                                    disabled={props.disabled}
                                                    data={{
                                                        listVariables: [],
                                                        listCalculos: state.listCalculos,
                                                        listFunciones: state.listFunciones,
                                                        listParametros: [],
                                                        listElementos: [],
                                                        listTiposDeclaracionJurada: []
                                                    }}
                                                    queueEvents={queueEvents}
                                                    queueName="Haber"
                                                />
                                                <FormError message={errorOf('formulaHaber')} />
                                            </div>
                                        </div>
                                    </Accordion>

                                </div>

                                {toolbar.show &&
                                    <ToolbarFormula
                                        data={{
                                            listCalculos: state.listCalculos.filter(f => f.idTipoEmisionCalculo === 242), //Resultado
                                            listVariables: [],
                                            listFunciones: state.listFunciones,
                                            listParametros: [],
                                            listElementos: [],
                                            listTiposDeclaracionJurada: []
                                        }}
                                        showVariables={false}
                                        showParametros={false}
                                        showElementos={false}
                                        showEntidades={false}
                                        onToogleHorizontal={handleToolbarFormulaToogleHorizontal}
                                        onSelect={handleToolbarFormulaSelect}
                                        onClose={ToogleToolbarShow}
                                    />
                                }
                            </div>
                )}
                footerClassName="modal-footer-unset"
                footer={(<>
                            {props.onMovePrevious &&
                                <button className="btn btn-i" data-dismiss="modal"
                                        onClick={(event) => props.onMovePrevious()}>
                                    <span className="material-symbols-outlined tooltip-container"
                                          title='Anterior'>chevron_left</span></button>
                            }
                            {props.onMoveNext &&
                                <button className="btn btn-i" data-dismiss="modal"
                                        onClick={(event) => props.onMoveNext()}>
                                    <span className="material-symbols-outlined tooltip-container"
                                          title='Siguiente'>chevron_right</span></button>
                            }
                            {!props.disabled && <>
                                <button className="btn btn-primary float-end" data-dismiss="modal"
                                        onClick={(event) => handleClickConfirm()}>Aceptar
                                </button>
                                <button className="btn btn-outline-primary float-end" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                            </>}
                            {props.disabled &&
                                <button className="btn back-button float-start" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver</button>
                            }
                </>)}
            />

        </>
    );
}

EmisionCuentaCorrienteModal.propTypes = {
    disabled: bool,
    partidaUnificada: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
    onMovePrevious: func,
    onMoveNext: func,
};

EmisionCuentaCorrienteModal.defaultProps = {
    disabled: false,
    onMovePrevious: null,
    onMoveNext: null
};

export default EmisionCuentaCorrienteModal;